import { AgentDatasetSchema } from "@redotech/redo-model/agents/agent-dataset";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const addItemToDataset = {
  name: "addItemToDataset" as const,
  input: z.object({
    datasetId: zExt.objectId(),
    initializationInputId: zExt.objectId(),
    originalThreadId: zExt.objectId(),
    expectedOutput: z.string(),
    notes: z.string().optional(),
  }),
  output: AgentDatasetSchema,
};
